// extracted by mini-css-extract-plugin
export default {"strip":"GameTimeStrip_strip__vgGmf","icon":"GameTimeStrip_icon__dYL7S","text":"GameTimeStrip_text__o0R9s"};